// extracted by mini-css-extract-plugin
module.exports = {"startGameButton":"StartGame_startGameButton__UrDZl"};